import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
    gqlStatusMessage,
    StatusMessage
} from "../../../../../../graphql/common.datatypes";

export interface MergeUserInput {
    data: {
        toUserId: number;
        fromUserId: number;
    };
}

interface MergeUserData {
    mergeUser: StatusMessage;
}

export const MERGE_USER_MUTATION = gql`
    mutation mergeUser($data: MergeUserInput!) {
        mergeUser(data: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const mergeUser = () =>
    useMutation<MergeUserData, MergeUserInput>(MERGE_USER_MUTATION);

export default mergeUser;
